import { h } from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import styles from './RangeSlider.module.scss';
// TODO: Implement range slider filter component
// - Add min/max range input
// - Handle range selection
// - Show current range values
// - Add step support
// - Add accessibility features
export function RangeSlider({ min, max, gap, currentMin, currentMax, onChange, }) {
    const [collectionBounds, setCollectionBounds] = useState({
        min,
        max,
    });
    const [displayValues, setDisplayValues] = useState({
        min: currentMin,
        max: currentMax,
    });
    const debounceTimeoutRef = useRef(null);
    const debouncedOnChange = (values) => {
        if (debounceTimeoutRef.current) {
            clearTimeout(debounceTimeoutRef.current);
        }
        debounceTimeoutRef.current = setTimeout(() => {
            onChange(values);
        }, 300);
    };
    useEffect(() => {
        setDisplayValues({
            min: currentMin,
            max: currentMax,
        });
    }, [currentMin, currentMax]);
    useEffect(() => {
        if (collectionBounds.min === undefined ||
            collectionBounds.max === undefined) {
            setCollectionBounds({
                min,
                max,
            });
        }
    }, [min, max]);
    useEffect(() => {
        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
        };
    }, []);
    const handleInput = (index) => (e) => {
        const newValue = parseInt(e.target.value, 10);
        let newValues;
        if (index === 0) {
            const constrainedMin = Math.min(newValue, displayValues.max - gap);
            newValues = [constrainedMin, displayValues.max];
        }
        else {
            const constrainedMax = Math.max(newValue, displayValues.min + gap);
            newValues = [displayValues.min, constrainedMax];
        }
        setDisplayValues({
            min: newValues[0],
            max: newValues[1],
        });
        debouncedOnChange(newValues);
    };
    const handleChange = (index) => (e) => {
        const newValue = parseInt(e.target.value, 10);
        let newValues;
        if (index === 0) {
            const constrainedMin = Math.min(newValue, displayValues.max - gap);
            newValues = [constrainedMin, displayValues.max];
        }
        else {
            const constrainedMax = Math.max(newValue, displayValues.min + gap);
            newValues = [displayValues.min, constrainedMax];
        }
        setDisplayValues({
            min: newValues[0],
            max: newValues[1],
        });
        debouncedOnChange(newValues);
    };
    return (h("div", { className: styles.rangeSlider },
        h("div", { className: styles.display },
            h("span", null,
                "$",
                displayValues.min),
            h("span", null,
                "$",
                displayValues.max)),
        h("div", { className: styles.inputs },
            h("input", { className: `${styles.input} ${styles.inputMin}`, type: "range", min: collectionBounds.min, max: collectionBounds.max, step: gap, value: displayValues.min, onInput: handleInput(0), onChange: handleChange(0) }),
            h("input", { className: `${styles.input} ${styles.inputMax}`, type: "range", min: collectionBounds.min, max: collectionBounds.max, step: gap, value: displayValues.max, onInput: handleInput(1), onChange: handleChange(1) }))));
}
